<template>
  <select
    :value="value"
    class="input-alo mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-alo-400 focus:border-alo-400 sm:text-sm"
    :class="{ 'with-errors': error }"
    @input="$emit('input', $event.target.value)"
  >
    " >
    <slot />
  </select>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: Object,
      default: null,
    },
  },
}
</script>
